<template>
  <div>
    <div class="tabs is-centered">
      <ul>
        <li :class="{ 'is-active': currentTab === 'leaderboard' }">
          <a
            href="#"
            @click.prevent="toggleTab('leaderboard')"
          ><span><ChevronTripleUp />&nbsp;</span>Leaderboard</a>
        </li>
        <li :class="{ 'is-active': currentTab === 'userSubmissions' }">
          <a
            href="#"
            @click.prevent="toggleTab('userSubmissions')"
          ><span><Video />&nbsp;</span>My Submissions</a>
        </li>
      </ul>
      <Filters />
    </div>
    <div
      v-if="loaded"
      class="tabs-content"
    >
      <div
        v-if="currentTab === 'leaderboard'"
      >
        <div>
          <SubmissionsList
            :source="'all'"
            :current-tab="currentTab"
            :event-id="event._id"
          />
        </div>
      </div>
      <div
        v-if="currentTab === 'userSubmissions'"
      >
        <Countdown
          v-if="!hasStarted && !hasEnded"
          :event="event"
          :start-date="startDate"
        />
        <SubmissionsList
          v-else
          :source="'user'"
          :current-tab="currentTab"
          :event-id="event._id"
        />
      </div>
    </div>

  </div>
</template>

<script>
import Countdown from '@/components/participants/Countdown'
import Filters from '@/components/Filters'
import SubmissionsList from '@/components/submissions/SubmissionsList'
import ChevronTripleUp from 'vue-material-design-icons/ChevronTripleUp'
import Video from 'vue-material-design-icons/Video'
import moment from 'moment-timezone'

export default {
  name: 'ParticipantDashboard',
  metaInfo: {
    title: `${process.env.VUE_APP_PAGE_TITLE} - Dashboard`
  },
  components: {
    Countdown,
    Filters,
    SubmissionsList,
    ChevronTripleUp,
    Video
  },
  data () {
    return {
      loaded: false,
      currentTab: 'userSubmissions'
    }
  },
  mounted () {
    let tab = this.$router.currentRoute.query.tab

    if (typeof tab !== 'undefined') {
      switch (tab) {
        case 'userSubmissions':
        default:
          this.currentTab = 'userSubmissions'
          break

        case 'leaderboard':
          this.currentTab = 'leaderboard'
          break
      }
    }
    if (Object.keys(this.event).length > 0) {
      this.loaded = true
    }
  },
  watch: {
    event () {
      if (Object.keys(this.event).length > 0) {
        this.loaded = true
      }
    }
  },
  computed: {
    event () {
      return this.$store.getters.currentEvent
    },
    startDate () {
      return moment(this.event.eventStartDate).tz('America/Chicago')
    },
    endDate () {
      return moment(this.event.eventEndDate).tz('America/Chicago')
    },
    hasStarted () {
      return this.startDate.isSameOrBefore(moment())
    },
    hasEnded () {
      return this.endDate.isBefore(moment())
    }
  },
  methods: {
    toggleTab (value) {
      this.$store.commit('saveTab', value)
      this.currentTab = value
    }
  }
}
</script>

<style lang="scss" scoped>
  .tabs{
    position: fixed;
    flex-direction: column;
    margin-bottom: 0;
    background: lighten($primary-color, 10%);
    width: 100%;
    overflow: visible;
    z-index: 10;

    ul{
      border: none;
      -webkit-box-shadow: inset 0px -5px 0px 0px $gray-darkest;
      -moz-box-shadow: inset 0px -5px 0px 0px $gray-darkest;
      box-shadow: inset 0px -3px 0px 0px $gray-darkest;
      width: 100%;
    }

    li{
      &.is-active{
        a{
          color: $yellow;
          border-bottom-color: $yellow;
        }
      }
      a{
        font-size: 1.2em;
        color: $white;
        border-bottom-width: 4px;

        &:hover{
          border-bottom-color: $yellow;
        }
      }
    }

    @include until($mobile){
      li{
        a{
          font-size: 1em;
        }
      }
    }
  }

  .tabs-content{
    padding-top: 50px;
  }
</style>
